import axios from 'axios';

// 서버 주소 한 곳에서 관리
// 2026-08 HTTPS(ims.ninegro.com) 적용 후 조치 — 예전엔 'http://nine-ims.iptime.org:3001/api'로
// 절대주소를 고정해뒀는데, 이러면 https://ims.ninegro.com처럼 HTTPS로 접속한 화면에서도 API
// 요청은 전부 http(평문)로 나가게 된다. 브라우저는 이런 "HTTPS 페이지에서 HTTP로 보내는 요청"을
// 보안상 자동으로 막아버린다(Mixed Content) — 로그인 화면은 뜨는데 로그인 버튼을 누르면 이유
// 없이 "오류가 발생했습니다"만 뜨는 게 바로 이 증상이다. 상대경로('/api')로 바꾸면 지금 화면을
// 불러온 주소(https://ims.ninegro.com이든, http://nine-ims.iptime.org:3001이든, 사내 IP:3001
// 이든)를 그대로 따라가므로 어떤 접속 방식에서도 항상 같은 origin으로 요청이 나간다.
const API = axios.create({ baseURL: '/api' });

// 모든 요청에 자동으로 토큰 붙이기
API.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// 401(인증 실패) 응답을 한 곳에서 처리 — 서버가 재시작되어 토큰의 serverInstanceId가 더 이상
// 맞지 않거나(middleware/auth.js), 토큰이 만료된 경우 등 "더 이상 로그인 상태가 아님"이 확인되면
// 세션을 정리하고 로그인 화면으로 보낸다. 로그인 화면 자체에서 발생하는 401(아이디/비밀번호
// 틀림)은 Login.js가 직접 에러 메시지로 처리하므로 여기서는 건드리지 않는다.
API.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || '';
    const isLoginRequest = url.includes('/auth/login');
    if (status === 401 && !isLoginRequest) {
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('user');
      sessionStorage.removeItem('loginLogId');
      sessionStorage.removeItem('lastActivityAt');
      // 다른 위치에서 메일 인증으로 기존 접속이 종료된 경우, 로그인 화면에서 안내할 수 있도록 남긴다
      if (error?.response?.data?.code === 'SESSION_REVOKED') {
        sessionStorage.setItem('ims_logout_notice', error.response.data.message || '세션이 종료되었습니다.');
      }
      // 다른 탭들도 즉시 같이 로그아웃되도록 방송 (AuthContext.js의 다중 탭 세션 동기화 참고).
      // 이 인터셉터는 React 트리 바깥(axios 설정)이라 useAuth()를 쓸 수 없어 직접 방송한다.
      try {
        if (typeof BroadcastChannel !== 'undefined') {
          new BroadcastChannel('ims_auth').postMessage({ type: 'LOGGED_OUT' });
        }
      } catch (e) { /* ignore */ }
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default API;